/** Wide hero-banner crop aspect ratio (width : height). */
export const BANNER_ASPECT = 3;

/**
 * Box-thumbnail crop aspect ratio (width : height). Matches the photo box of
 * the small "find" discovery cards (marketplace EntityCard, ProducerCollabBlock),
 * which render at 16:11.
 */
export const BOX_ASPECT = 16 / 11;
